import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from '../GridCellBase';

const LineItemLabelCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const values = ['shipping', 'taxes', 'discount'];
  const itemText = values.includes(dataItem?.item?.toLowerCase())
    ? dataItem.item
    : `Item #: ${dataItem.item}`;
  return <GridCellBase {...props}>{itemText}</GridCellBase>;
};

export default LineItemLabelCell;
